import React, { useEffect, useState } from "react";
import { PageHero, DraftNotice } from "@/components/common/SectionHeading";
import { fetchLeadership } from "@/lib/lnlApi";

export default function Leadership() {
    const [rows, setRows] = useState([]);
    useEffect(() => { fetchLeadership().then(setRows); }, []);
    return (
        <div data-testid="leadership-page">
            <PageHero eyebrow="Leadership" title="LNL Leadership" description="School Officers and administrative leaders." breadcrumbs={[{label:"Home",to:"/"},{label:"About LNL",to:"/about"},{label:"Leadership"}]} />
            <section className="py-10 bg-white">
                <div className="lnl-container">
                    <DraftNotice tone="warn">Every leadership record is seeded from currently published information and marked "Verification Required Before Launch". Personal telephone numbers and private emails are never published.</DraftNotice>
                    <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {rows.map((l) => (
                            <div key={l.id} className="lnl-card p-5" data-testid={`leader-${l.order}`}>
                                <div className="w-14 h-14 rounded-full bg-lnl-green-bg text-lnl-green-deep font-heading font-bold grid place-items-center text-xl mb-4">{l.name.split(" ").map((x)=>x[0]).join("").slice(0,2)}</div>
                                <div className="font-heading font-bold text-lnl-charcoal">{l.name}</div>
                                <div className="text-sm text-lnl-gray">{l.title}</div>
                                <div className="mt-3 text-[10px] uppercase tracking-widest font-heading font-semibold text-amber-800 bg-amber-50 border border-amber-200 rounded px-2 py-0.5 inline-block">Verification required</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
